import { render, staticRenderFns } from "./CollectionResults.vue?vue&type=template&id=01715dce&scoped=true&"
import script from "./CollectionResults.vue?vue&type=script&lang=js&"
export * from "./CollectionResults.vue?vue&type=script&lang=js&"
import style0 from "./CollectionResults.vue?vue&type=style&index=0&id=01715dce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01715dce",
  null
  
)

export default component.exports